var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.9033C5.12982 17.5791 5.40243 16.3262 5.81784 15.1443C6.23325 13.9635 6.80444 12.8539 7.53141 11.8153C8.44012 12.75 9.1998 13.8337 9.81045 15.0664C10.4201 16.3002 10.8157 17.5791 10.9975 18.9033H5ZM30.0025 18.9033C30.1843 17.5791 30.5737 16.3069 31.1709 15.0867C31.768 13.8664 32.5339 12.7889 33.4686 11.8543C34.1956 12.8668 34.7667 13.9703 35.1822 15.1646C35.5976 16.3589 35.8702 17.6051 36 18.9033H30.0025ZM7.53141 29.1457C6.80444 28.1332 6.23325 27.0365 5.81784 25.8557C5.40243 24.6738 5.12982 23.4209 5 22.0967H10.9975C10.8157 23.4209 10.4201 24.693 9.81045 25.9133C9.1998 27.1336 8.44012 28.2111 7.53141 29.1457ZM33.4686 29.1457C32.5339 28.2111 31.768 27.1336 31.1709 25.9133C30.5737 24.693 30.1843 23.4209 30.0025 22.0967H36C35.8702 23.3949 35.5976 24.6411 35.1822 25.8354C34.7667 27.0297 34.1956 28.1332 33.4686 29.1457ZM14.152 18.9033C13.9443 17.0339 13.438 15.3074 12.6332 13.7236C11.8283 12.1399 10.7768 10.7119 9.47864 9.4397C10.7249 8.19347 12.1466 7.19389 13.7439 6.44095C15.3401 5.68802 17.0599 5.20771 18.9033 5V18.9033H14.152ZM22.0967 18.9033V5C23.9401 5.20771 25.6599 5.68802 27.2561 6.44095C28.8534 7.19389 30.2751 8.19347 31.5214 9.4397C30.1972 10.6859 29.1395 12.1072 28.3481 13.7034C27.5557 15.3006 27.0557 17.0339 26.848 18.9033H22.0967ZM18.9033 36C17.0339 35.7923 15.3074 35.3052 13.7236 34.5388C12.1399 33.7734 10.7249 32.7676 9.47864 31.5214C10.8028 30.2751 11.861 28.8601 12.6534 27.2764C13.4448 25.6926 13.9443 23.9661 14.152 22.0967H18.9033V36ZM22.0967 36V22.0967H26.848C27.0557 23.9661 27.5557 25.6989 28.3481 27.2951C29.1395 28.8923 30.1972 30.3141 31.5214 31.5603C30.2751 32.8065 28.8534 33.8061 27.2561 34.559C25.6599 35.312 23.9401 35.7923 22.0967 36Z",
    fill: "url(#paint0_linear_1125_987)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_987",
    x1: 20.5,
    y1: 5,
    x2: 20.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBollIcon);
export default __webpack_public_path__ + "static/media/bollIcon.a40011a7b0799e477e3d525c29d67f90.svg";
export { ForwardRef as ReactComponent };